export default class Login {

	constructor(name){
		window.dataLayer = window.dataLayer || [];
		window[name] = this.data()
	}


	data(){

		return {
			showTwoFactorForm: false,
			showPasswordForgotForm: false,
			showPasswordChangeForm: false,
			errorMessage: null,
			errorMessageForgot: null,
			dashboardUrl: null,
			succesMessage: null,
			ResendTwoFactorcount: 0,

			contactField: {
				email: '',
				password: ''
			},
			twofactorField: {
				token: '',
				uid: null
			},
			forgotPasswordField: {
				email: '',
				token: '',
				password: '',
				password_confirm: ''
			},

			Login(vm = this) {
				var xhttp = new XMLHttpRequest();
				vm.errorMessage = null
				xhttp.onreadystatechange = function() {
					console.log( this.readyState , this.status )
					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.responseText);
						if (typeof(response.error) !== 'undefined') {
							vm.errorMessage = response.error
							return false
						}
						if (typeof(response.validation) !== 'undefined') {
							vm.ValidationResponse(response.validation);
							return false
						}
						vm.resetErrorMessage()
						vm.showTwoFactorForm = true
						vm.showTwoFactorForm = true
						vm.twofactorField.uid = response.data.loginContact.uid;
					}
				};
				xhttp.open('post', '/woonmens/api/login', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttp.send(JSON.stringify(this.contactField));
			},

			Twofactor() {
				var xhttptwofactor = new XMLHttpRequest();
				var vm = this
				vm.errorMessage = null
				xhttptwofactor.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.response);
						console.log(response.data)
						if ( response.data.twoFactorContact == null ) {
							vm.succesMessage = null
							vm.errorMessage = 'Uw token is onjuist of reeds verlopen.'	
							return 
						}
						window.dataLayer.push({'event': 'user_login'});
						window.location.href = vm.dashboardUrl;

					}
				};
				xhttptwofactor.open('post', '/woonmens/api/login-2fa', true);
				xhttptwofactor.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttptwofactor.send(JSON.stringify(this.twofactorField));
			},
			ResendTwoFactor(){
				if(!this.IsAllowedToResend2FACode) {
					this.succesMessage = false;
					return false; 
				}

				var xhttptwofactor = new XMLHttpRequest();
				var vm = this
				xhttptwofactor.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.response);
						vm.errorMessage = null
						vm.succesMessage = 'Verificatiecode opnieuw verzonden'
						vm.ResendTwoFactorcount++
						console.log(vm.ResendTwoFactorcount)
					}
				};
				xhttptwofactor.open('post', '/woonmens/api/resend-2fa-code', true);
				xhttptwofactor.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttptwofactor.send(JSON.stringify({'uid': this.twofactorField.uid }));
			},

			ForgotPassword(){
				var xhttptwofactor = new XMLHttpRequest();
				var vm = this
				xhttptwofactor.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.response);

						if( 'validation' in  response){
							vm.errorMessage = response.validation.email[0]
							return
						}
						
						if( 'data' in response && response.data.sendForgotPasswordToken ){
							vm.showPasswordForgotForm = false;
							vm.showPasswordChangeForm = true;
						}else{
							vm.errorMessage = 'Het opgegeven e-mailadres is bij ons niet bekend.'
						}

					}
				};
				xhttptwofactor.open('post', '/woonmens/api/forgot-password', true);
				xhttptwofactor.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttptwofactor.send(JSON.stringify(this.forgotPasswordField));
			},
			ChangePassword(){
				var xhttptwofactor = new XMLHttpRequest();
				var vm = this
				xhttptwofactor.onreadystatechange = function() {

					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.response);
						if (typeof(response.error) !== 'undefined') {
							vm.errorMessage = response.error
							return false
						}
						if (typeof(response.validation) !== 'undefined') {
							vm.ValidationResponse(response.validation);
							return false
						}
						if ( response.data.changePasswordMutation == null ) {
							vm.errorMessageForgot = 'Uw token is onjuist of reeds verlopen';
							return
						}

						window.location.replace('/account/login');

					}
				};
				xhttptwofactor.open('post', '/woonmens/api/change-password', true);
				xhttptwofactor.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				xhttptwofactor.send(JSON.stringify(this.forgotPasswordField));
			},

			IsAllowedToResend2FACode(){
			 if(this.ResendTwoFactorcount < 4){
			 	return true;
			 }

			 return false;
			},

			
			ValidationResponse(ValidationResponse) {
				document.querySelectorAll('.has-errors').forEach(el => el.classList.remove('has-errors'));
				document.querySelectorAll('.woonmens-validation-message').forEach(el => el.remove());
				if (typeof(ValidationResponse) !== 'undefined') {
					Object.keys(ValidationResponse).forEach(function(item) {
						console.log(item);
						var el = document.querySelector('[name="' + item + '"]')
						if (el) {
							el.parentNode.classList.add('has-errors')
							el.insertAdjacentHTML('afterend', '<div class="woonmens-validation-message">' + ValidationResponse[item] + '</div>');
							el.addEventListener('focus', function() {
								el.parentNode.classList.remove('has-errors')
								var next = el.nextSibling
								if( next ) next.remove();
							})
						}
					});
				};
			},

			resetErrorMessage(){
				this.errorMessage = null
				this.errorMessageForgot = null
			},

			showPasswordForgotFormTrigger(){
				this.resetErrorMessage()
				this.showPasswordForgotForm ^= true;
			},

			shouldShowLoginForm(){
				if(this.showTwoFactorForm || this.showPasswordForgotForm || this.showPasswordChangeForm){
					return false;
				}else{
					return true;
				}
			},
			shouldShowTwoFactorForm(){
				if(this.showTwoFactorForm){
					return true;
				}
			},
			shouldShowPasswordForgotForm(){
				if(this.showPasswordForgotForm){
					return true;
				}	
			},
			shouldShowPasswordChangeForm(){
				if(this.showPasswordChangeForm){
					return true;
				}	
			}
		}
	}
}
